import React, { useState } from 'react';
import { CheckboxRegularWrapper, StyledCheckbox, Hint } from '../styles';
import Portal from '../AddressCell/Portal';


const CheckboxPrimaryCell = ({ disabled }) => {
    const [showHint, setShowHint] = useState(false);
    return (
        <CheckboxRegularWrapper
            onMouseEnter={() => setShowHint(true)}
            onMouseLeave={() => setShowHint(false)}
        >
            <StyledCheckbox
                type="checkbox"
                disabled
            />
            {showHint && (
                <Hint>
                    {'Primary residence cannot be selected, deleted, or moved to another group.'}
                </Hint>
            )}
        </CheckboxRegularWrapper>
    )
}
export default CheckboxPrimaryCell;
